import { transport } from 'config/transport';

export function callApiCreateNun(congDoanId, body) {
    return transport.post(`/congdoan/${congDoanId}/nun`, body);
}
